import React, { useRef, useState } from "react";
import { Toast } from "primereact/toast";

export default function FileUploader({ onFileChange, label = "Joindre un fichier", maxSize = 20 }) {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const fileInputRef = useRef(null);
  const toast = useRef(null);


  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size <= maxSize * 1024 * 1024) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
      if (onFileChange) onFileChange(selectedFile);
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Fichier trop volumineux",
        detail: `Vous avez dépassé la taille maximale autorisée : ${maxSize} Mo.`,
        life: 5000,
      });
      setFile(null);
      setFileName("");
    }
  };

  const handleFileDelete = () => {
    setFile(null);
    setFileName("");
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset the file input
    }
    if (onFileChange) onFileChange(null);
  };

  return (
    
    <div className="fileUploader">
      <Toast ref={toast} />
      
      {fileName ? (
        <div className="fileDetails">
          <span>{fileName}</span>
          <button
            type="button"
            className="deleteFileButton"
            onClick={handleFileDelete}
          >
            ✕
          </button>
        </div>
      ) : (
        <label htmlFor="file" className="fileInput">
          <i className="pi pi-cloud-upload" style={{ fontSize: "15px" }}> </i>
          {label}
        </label>
      )}
      <input
        type="file"
        id="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      <small className="fileSizeLimit">La taille maximum : {maxSize} Mo</small>
    </div>
  );
}
